import React, { useState, useEffect } from 'react'
import { Button, Col, DatePicker, Input, InputNumber, Modal, Row } from 'antd'
import moment from 'moment'
import LocationPickerModal from '../../components/LocationPickerModal'

const { TextArea } = Input

// Captures the ACTUAL start/end details (datetime + geo + remarks) for a trip.
function TripActionModal ({ visible, mode, trip, onSubmit, onCancel, loading }) {
  const [dateTime, setDateTime] = useState(moment())
  const [lat, setLat] = useState(undefined)
  const [lng, setLng] = useState(undefined)
  const [address, setAddress] = useState(undefined)
  const [remarks, setRemarks] = useState(undefined)
  const [pickerVisible, setPickerVisible] = useState(false)

  const isStart = mode === 'start'
  const proposed = trip && (isStart ? trip.proposedStartLocation : trip.proposedEndLocation)

  useEffect(() => {
    if (visible) {
      setDateTime(moment())
      // Prefill location from the proposed value as a convenience.
      setLat(proposed && proposed.latitude != null ? proposed.latitude : undefined)
      setLng(proposed && proposed.longitude != null ? proposed.longitude : undefined)
      setAddress(proposed && proposed.address ? proposed.address : undefined)
      setRemarks(undefined)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible, trip && trip._id, mode])

  const handleOk = () => {
    const location = (lat === undefined || lat === '') && (lng === undefined || lng === '') && !address
      ? undefined
      : {
        latitude: lat === undefined || lat === '' ? null : Number(lat),
        longitude: lng === undefined || lng === '' ? null : Number(lng),
        address: address || undefined
      }
    onSubmit({
      dateTime: dateTime ? dateTime.toISOString() : undefined,
      location,
      remarks: remarks || undefined
    })
  }

  return (
    <Modal
      title={`${isStart ? 'Start' : 'End'} Trip${trip && trip.tripNo ? ` - ${trip.tripNo}` : ''}`}
      visible={visible}
      onOk={handleOk}
      onCancel={onCancel}
      okText={isStart ? 'Start Trip' : 'End Trip'}
      confirmLoading={loading}
      destroyOnClose
    >
      <div style={{ marginBottom: 12 }}>
        <div style={{ marginBottom: 4 }}>Actual {isStart ? 'Start' : 'End'} Date &amp; Time</div>
        <DatePicker
          showTime
          format='DD/MM/YYYY HH:mm'
          style={{ width: '100%' }}
          value={dateTime}
          disabledDate={(current) => current && current > moment().endOf('day')}
          onChange={(v) => setDateTime(v)}
        />
      </div>

      <div style={{ marginBottom: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span>Actual {isStart ? 'Start' : 'End'} Location</span>
        <Button size='small' icon='environment' onClick={() => setPickerVisible(true)}>Select on map</Button>
      </div>
      <Row gutter={12}>
        <Col xs={12}>
          <InputNumber style={{ width: '100%' }} placeholder='Latitude' step={0.000001} value={lat} onChange={setLat} />
        </Col>
        <Col xs={12}>
          <InputNumber style={{ width: '100%' }} placeholder='Longitude' step={0.000001} value={lng} onChange={setLng} />
        </Col>
      </Row>
      <Input style={{ marginTop: 8 }} placeholder='Address (optional)' value={address} onChange={(e) => setAddress(e.target.value)} />

      <LocationPickerModal
        visible={pickerVisible}
        initialLat={lat}
        initialLng={lng}
        initialAddress={address}
        onOk={({ latitude, longitude, address: addr }) => {
          setLat(latitude)
          setLng(longitude)
          if (addr) setAddress(addr)
          setPickerVisible(false)
        }}
        onCancel={() => setPickerVisible(false)}
      />

      <div style={{ marginTop: 12 }}>
        <div style={{ marginBottom: 4 }}>Remarks (optional)</div>
        <TextArea rows={2} value={remarks} onChange={(e) => setRemarks(e.target.value)} />
      </div>
    </Modal>
  )
}

export default TripActionModal
